import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import UpdateAcademicStandardFrameworkDTO from '../models/academic/UpdateAcademicStandardFrameworkDTO';
import AcademicStandardFrameworkDTO from '../models/academic/AcademicStandardFrameworkDTO';
import TableResponseDTO from '../models/datatable/TableResponseDTO';
import KeyValueListDTO from '../models/generic/KeyValueListDTO';
import UpdateAcademicStandardDTO from '../models/academic/UpdateAcademicStandardDTO';
import AcademicStandardDTO from '../models/academic/AcademicStandardDTO';
import AddAcademicStandardFrameworkDTO from '../models/academic/AddAcademicStandardFrameworkDTO';
import TableRequestDTO from '../models/datatable/TableRequestDTO';
import AddAcademicStandardDTO from '../models/academic/AddAcademicStandardDTO';

export class AcademicApiController {
    // post: Academic/AddAcademicStandardFramework
    public RouteAddAcademicStandardFramework = () => `Academic/AddAcademicStandardFramework`;
    public addAcademicStandardFramework(addAcademicStandardFramework: AddAcademicStandardFrameworkDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteAddAcademicStandardFramework();
        return HttpApi.RestRequest<any, void>(addAcademicStandardFramework, 'post', url, requestOptions);
    }
    // post: Academic/UpdateAcademicStandardFramework
    public RouteUpdateAcademicStandardFramework = () => `Academic/UpdateAcademicStandardFramework`;
    public updateAcademicStandardFramework(updateAcademicStandardFramework: UpdateAcademicStandardFrameworkDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteUpdateAcademicStandardFramework();
        return HttpApi.RestRequest<any, void>(updateAcademicStandardFramework, 'post', url, requestOptions);
    }
    // post: Academic/DeleteAcademicStandardFramework/${academicStandardFrameworkId}
    public RouteDeleteAcademicStandardFramework = (academicStandardFrameworkId: number) => `Academic/DeleteAcademicStandardFramework/${academicStandardFrameworkId}`;
    public deleteAcademicStandardFramework(academicStandardFrameworkId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteDeleteAcademicStandardFramework(academicStandardFrameworkId);
        return HttpApi.RestRequest<any, void>(null, 'post', url, requestOptions);
    }
    // get: Academic/GetAcademicStandardFramework/${academicStandardFrameworkId}
    public RouteGetAcademicStandardFramework = (academicStandardFrameworkId: number) => `Academic/GetAcademicStandardFramework/${academicStandardFrameworkId}`;
    public getAcademicStandardFramework(academicStandardFrameworkId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<UpdateAcademicStandardFrameworkDTO>> {
        let url = this.RouteGetAcademicStandardFramework(academicStandardFrameworkId);
        return HttpApi.RestRequest<any, UpdateAcademicStandardFrameworkDTO>(null, 'get', url, requestOptions);
    }
    // post: Academic/GetAcademicStandardFrameworksForDatatable
    public RouteGetAcademicStandardFrameworksForDatatable = () => `Academic/GetAcademicStandardFrameworksForDatatable`;
    public getAcademicStandardFrameworksForDatatable(tableRequest: TableRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<AcademicStandardFrameworkDTO>>> {
        let url = this.RouteGetAcademicStandardFrameworksForDatatable();
        return HttpApi.RestRequest<any, TableResponseDTO<AcademicStandardFrameworkDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // get: Academic/GetAcademicStandardFrameworksForAcademicStandard
    public RouteGetAcademicStandardFrameworksForAcademicStandard = () => `Academic/GetAcademicStandardFrameworksForAcademicStandard`;
    public getAcademicStandardFrameworksForAcademicStandard(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueListDTO>> {
        let url = this.RouteGetAcademicStandardFrameworksForAcademicStandard();
        return HttpApi.RestRequest<any, KeyValueListDTO>(null, 'get', url, requestOptions);
    }
    // post: Academic/AddAcademicStandard
    public RouteAddAcademicStandard = () => `Academic/AddAcademicStandard`;
    public addAcademicStandard(addAcademicStandard: AddAcademicStandardDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteAddAcademicStandard();
        return HttpApi.RestRequest<any, void>(addAcademicStandard, 'post', url, requestOptions);
    }
    // post: Academic/UpdateAcademicStandard
    public RouteUpdateAcademicStandard = () => `Academic/UpdateAcademicStandard`;
    public updateAcademicStandard(updateAcademicStandard: UpdateAcademicStandardDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteUpdateAcademicStandard();
        return HttpApi.RestRequest<any, void>(updateAcademicStandard, 'post', url, requestOptions);
    }
    // post: Academic/DeleteAcademicStandard/${academicStandardId}
    public RouteDeleteAcademicStandard = (academicStandardId: number) => `Academic/DeleteAcademicStandard/${academicStandardId}`;
    public deleteAcademicStandard(academicStandardId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteDeleteAcademicStandard(academicStandardId);
        return HttpApi.RestRequest<any, void>(null, 'post', url, requestOptions);
    }
    // get: Academic/GetAcademicStandard/${academicStandardId}
    public RouteGetAcademicStandard = (academicStandardId: number) => `Academic/GetAcademicStandard/${academicStandardId}`;
    public getAcademicStandard(academicStandardId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<UpdateAcademicStandardDTO>> {
        let url = this.RouteGetAcademicStandard(academicStandardId);
        return HttpApi.RestRequest<any, UpdateAcademicStandardDTO>(null, 'get', url, requestOptions);
    }
    // post: Academic/GetAcademicStandardsForDatatable
    public RouteGetAcademicStandardsForDatatable = () => `Academic/GetAcademicStandardsForDatatable`;
    public getAcademicStandardsForDatatable(tableRequest: TableRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<AcademicStandardDTO>>> {
        let url = this.RouteGetAcademicStandardsForDatatable();
        return HttpApi.RestRequest<any, TableResponseDTO<AcademicStandardDTO>>(tableRequest, 'post', url, requestOptions);
    }
}
var service = new AcademicApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/AcademicApiController.ts